<template>
  <div>
    <section class="section--pt-xlg">
      <div class="inner">
        <h2 class="Head__blue">
          このクラスの開始前に通知が届きます
        </h2>
        <router-link class="Btn Btn__line Btn__line--sp_line" to="/change/notification">
          通知時間を変える場合はこちら
        </router-link>
        <div v-if="listClasses.length == 0" id="notification-class" class="Notification">
          <div class="Error__box Error__box_class">
            <p class="Error__box_tx">
              ホーム画面でクラスをタップし「通知する」にチェックをいれると、クラス開始前に通知が届きます。
            </p>
          </div>
        </div>
        <div v-if="listClasses.length > 0 && !isMobile" id="notification-class" class="Notification">
          <div class="Notification__area">
            <div
              v-for="(scheduleClassOfDate,id) of listClasses"
              :id="`${id}`"
              :key="id"
              :class="`Notification__box ${scheduleClassOfDate.is_same_day && !scheduleClassOfDate.is_last_day ? 'Notification__box--line' : ''}`"
            >
              <div class="Notification__left">
                <div
                  class="Notification__date_box Notification__date--position"
                >
                  <div class="Notification__date">
                    {{ showDate(scheduleClassOfDate.date) }}
                  </div>
                  <div class="Notification__day">
                    &#040;{{ showDay(scheduleClassOfDate.date) }}&#041;
                  </div>
                </div>
                <div
                  class="Notification__left_line Notification__date--position"
                />
              </div>
              <div class="Notification__main" :class="{ _active: activeItem[scheduleClassOfDate.id], _last: id === (listClasses.length - 1) }">
                <div class="Notification__schedule_box">
                  <div class="Notification__time" style="white-space: nowrap;">
                    {{ scheduleClassOfDate.learning_time }}
                  </div>
                  <div class="Notification_class_box">
                    <div class="Notification_class">
                      {{ scheduleClassOfDate.master_program_category.name }}
                      <span class="Notification_class_time">
                        {{ scheduleClassOfDate.time }}
                      </span>
                    </div>
                    <div class="Notification_instructor">
                      {{ scheduleClassOfDate.master_instructor.name }}
                    </div>
                  </div>
                </div>
                <div class="Notification_btn">
                  <span
                    class="Notification_btn_tx Notification_btn_tx_register"
                    @click="toggleActive(scheduleClassOfDate)"
                  >再登録</span><span
                    class="Notification_btn_tx Notification_btn_tx_cancel"
                    @click="toggleActive(scheduleClassOfDate)"
                  >取り消し</span>
                </div>
              </div>
            </div>
          </div>
          <div class="Notification__area">
            <div
              v-for="(scheduleClassOfDate,id) of listClassesRight"
              :id="`${id}`"
              :key="id"
              :class="`Notification__box ${scheduleClassOfDate.is_last_day ? '' : ''} ${scheduleClassOfDate.is_same_day && !scheduleClassOfDate.is_last_day ? 'Notification__box--line' : ''}`"
            >
              <div class="Notification__left">
                <div
                  class="Notification__date_box Notification__date--position"
                >
                  <div class="Notification__date">
                    {{ showDate(scheduleClassOfDate.date) }}
                  </div>
                  <div class="Notification__day">
                    &#040;{{ showDay(scheduleClassOfDate.date) }}&#041;
                  </div>
                </div>
                <div
                  class="Notification__left_line Notification__date--position"
                />
              </div>
              <div class="Notification__main" :class="{ _active: activeItem[scheduleClassOfDate.id], _last: id === (listClassesRight.length - 1) }">
                <div class="Notification__schedule_box">
                  <div class="Notification__time" style="white-space: nowrap;">
                    {{ scheduleClassOfDate.learning_time }}
                  </div>
                  <div class="Notification_class_box">
                    <div class="Notification_class">
                      {{ scheduleClassOfDate.master_program_category.name }}
                      <span class="Notification_class_time">
                        {{ scheduleClassOfDate.time }}
                      </span>
                    </div>
                    <div class="Notification_instructor">
                      {{ scheduleClassOfDate.master_instructor.name }}
                    </div>
                  </div>
                </div>
                <div class="Notification_btn" @click="toggleActive(scheduleClassOfDate)">
                  <span
                    class="Notification_btn_tx Notification_btn_tx_register"
                  >再登録</span><span
                    class="Notification_btn_tx Notification_btn_tx_cancel"
                  >取り消し</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="listClasses.length > 0 && isMobile" id="notification-class" class="Notification">
          <div class="Notification__area">
            <div
              v-for="(scheduleClassOfDate,id) of listClasses"
              :id="`${id}`"
              :key="id"
              :class="`Notification__box ${scheduleClassOfDate.is_same_day ? 'Notification__box--line' : ''}`"
            >
              <div class="Notification__left">
                <div
                  class="Notification__date_box Notification__date--position"
                >
                  <div class="Notification__date">
                    {{ showDate(scheduleClassOfDate.date) }}
                  </div>
                  <div class="Notification__day">
                    &#040;{{ showDay(scheduleClassOfDate.date) }}&#041;
                  </div>
                </div>
                <div
                  class="Notification__left_line Notification__date--position"
                />
              </div>
              <div class="Notification__main" :class="{ _active: activeItem[scheduleClassOfDate.id] }">
                <div class="Notification__schedule_box">
                  <div class="Notification__time" style="white-space: nowrap;">
                    {{ scheduleClassOfDate.learning_time }}
                  </div>
                  <div class="Notification_class_box">
                    <div class="Notification_class">
                      {{ scheduleClassOfDate.master_program_category.name }}
                      <span class="Notification_class_time">
                        {{ scheduleClassOfDate.time }}
                      </span>
                    </div>
                    <div class="Notification_instructor">
                      {{ scheduleClassOfDate.master_instructor.name }}
                    </div>
                  </div>
                </div>
                <div class="Notification_btn">
                  <span
                    class="Notification_btn_tx Notification_btn_tx_register"
                    @click="toggleActive(scheduleClassOfDate)"
                  >再登録</span><span
                    class="Notification_btn_tx Notification_btn_tx_cancel"
                    @click="toggleActive(scheduleClassOfDate)"
                  >取り消し</span>
                </div>
              </div>
            </div>
          </div>
          <div class="Notification__area">
            <div
              v-for="(scheduleClassOfDate,id) of listClassesRight"
              :id="`${id}`"
              :key="id"
              :class="`Notification__box ${scheduleClassOfDate.is_same_day ? 'Notification__box--line' : ''}`"
            >
              <div class="Notification__left">
                <div
                  class="Notification__date_box Notification__date--position"
                >
                  <div class="Notification__date">
                    {{ showDate(scheduleClassOfDate.date) }}
                  </div>
                  <div class="Notification__day">
                    &#040;{{ showDay(scheduleClassOfDate.date) }}&#041;
                  </div>
                </div>
                <div
                  class="Notification__left_line Notification__date--position"
                />
              </div>
              <div class="Notification__main" :class="{ _active: activeItem[scheduleClassOfDate.id] }">
                <div class="Notification__schedule_box">
                  <div class="Notification__time" style="white-space: nowrap;">
                    {{ scheduleClassOfDate.learning_time }}
                  </div>
                  <div class="Notification_class_box">
                    <div class="Notification_class">
                      {{ scheduleClassOfDate.master_program_category.name }}
                      <span class="Notification_class_time">
                        {{ scheduleClassOfDate.time }}
                      </span>
                    </div>
                    <div class="Notification_instructor">
                      {{ scheduleClassOfDate.master_instructor.name }}
                    </div>
                  </div>
                </div>
                <div class="Notification_btn" @click="toggleActive(scheduleClassOfDate)">
                  <span
                    class="Notification_btn_tx Notification_btn_tx_register"
                  >再登録</span><span
                    class="Notification_btn_tx Notification_btn_tx_cancel"
                  >取り消し</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import favoriteService from '@/services/favoriteService'
import moment from 'moment'
export default {
  name: 'ClassNotification',
  data() {
    return {
      listClasses: [],
      listClassesRight: [],
      activeItem: {},
      isMobile: false,
      width: 0,
      height: 0
    }
  },
  watch: {
    isMobile: function() {
      this.getListClasses()
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  updated() {
    this.isMobile
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  mounted() {
    this.getListClasses()
  },
  methods: {
    handleResize() {
      this.width = window.innerWidth
      this.height = window.innerHeight
      if (this.width <= 767) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    showTime(time) {
      return time + ' min'
    },
    async getListClasses() {
      const response = await favoriteService.index()
      this.listClasses = response.data.left
      this.listClassesRight = response.data.right
      this.listClasses.forEach(element => {
        element.date = moment(element.date).local()
        element.learning_time = element.date.format('HH:mm')
        element.learning_day = this.showDay(element.date)
      })
      this.listClassesRight.forEach(element => {
        element.date = moment(element.date).local()
        element.learning_time = element.date.format('HH:mm')
        element.learning_day = this.showDay(element.date)
      })
      if (this.isMobile) {
        this.handleListClass(this.listClasses.concat(this.listClassesRight))
      } else {
        this.handleListClass(response.data.left)
        this.handleListClass(response.data.right)
      }
    },
    handleListClass(listClass) {
      for (const [key] of Object.entries(listClass)) {
        listClass[parseInt(key)].is_last_day = false
        listClass[parseInt(key)].is_same_day = false
        // Check if currentday = previous learning day
        // Same day
        if (
          listClass[parseInt(key) - 1] !== undefined &&
          listClass[parseInt(key) - 1].learning_day === listClass[parseInt(key)].learning_day
        ) {
          listClass[parseInt(key)].is_same_day = true
        }
        // Check if next day = current day
        // Last day
        if (
          listClass[parseInt(key) + 1] !== undefined && listClass[parseInt(key) + 1].learning_day !== listClass[parseInt(key)].learning_day ||
          listClass[parseInt(key) + 1] === undefined
        ) {
          listClass[parseInt(key)].is_last_day = true
        }
      }
    },
    showDate(date) {
      if (date !== null) {
        return moment(date).format('M.DD')
      }
    },
    showDay(date) {
      if (date !== null) {
        return moment(date).format('ddd')
      }
    },
    toggleActive(item) {
      if (this.activeItem[item.id]) {
        this.removeActiveItem(item)
        return
      }
      this.addActiveItem(item)
    },
    addActiveItem(item) {
      this.activeItem = Object.assign({},
        this.activeItem,
        { [item.id]: item }
      )
      favoriteService.addClassFavorite(item.id)
    },
    removeActiveItem(item) {
      delete this.activeItem[item.id]
      this.activeItem = Object.assign({}, this.activeItem)
      favoriteService.addClassFavorite(item.id)
    }
  }
}
</script>

